<script>
// import { required } from "vuelidate/lib/validators";
import {
  productListMethods,
  productListComputed,
  layoutMethods,
  erpUserRolesMethods,
} from "@/state/helpers";
import Swal from "sweetalert2";
import ImageUpload from "@/components/ImageUpload";
import { getModuleAccess } from "@/router/helper.js";

/**
 * Manage Categories
 */
export default {
  page: {
    title: "Manage eSupplies Business Category",
  },
  data() {
    return {
      action: "",
      promoId: 0,
      folder: "seller-categories",
      logoPreview: null,
      businessLogo: {
        filename: null,
        type: null,
        base64: null,
      },
      businessCategoryItem: {
        productId: null,
        productName: "",
        productImageSrc: "",
      },
      formExitChecker: {
        productId: null,
        productName: "",
        productImageSrc: "",
      },
      submitted: false,
      businessCategoryModule: {
        access: {
          create: true,
          read: true,
          update: true,
          delete: true,
        },
      },
    };
  },
  components: {
    ImageUpload,
  },
  validations: {},
  computed: {
    ...productListComputed,
  },
  mounted: async function () {
    this.action = this.$route.params.action;
    this.categoryId = this.$route.params.id;
    this.changeTitle({
      title: (this.action == "add" ? "Add" : "Edit") + " Business Category",
    });
    this.changeBreadCrumb({
      breadCrumbs: [
        { text: 'Peddlr', to: { name: 'Home'} },
        { text: 'Business Category', to: { name: 'Business Category'} },
        {
          text: `${this.action == "add" ? "Add" : this.categoryId}`,
          to: { name: "" },
        },
      ],
    });

    if (this.action == "edit") {
      await this.getCategoryById();
    }

    // get the module access for checking if user has create, read, update, and/or delete access
    await getModuleAccess('Utilities', 'Business Category')
      .then((access) => this.businessCategoryModule.access = access);
  },
  methods: {
    ...layoutMethods,
    ...productListMethods,
    ...erpUserRolesMethods,
    async getCategoryById() {
      let params = {
        search: this.categoryId,
        search_field: "id",
      };
      await this.listBusinessCategories(params).then(() => {
        this.businessCategoryItem.productId = this.businessCategories[0].productId;
        this.businessCategoryItem.productName = this.businessCategories[0].productName;
        this.businessCategoryItem.productImageSrc = this.businessCategories[0].productImageSrc != '' ? 
          this.businessCategories[0].productImageSrc : require('@/assets/images/img-placeholder.png');

        this.formExitChecker.productId = this.businessCategories[0].productId;
        this.formExitChecker.productName = this.businessCategories[0].productName;
        this.formExitChecker.productImageSrc = this.businessCategories[0].productImageSrc != '' ? 
          this.businessCategories[0].productImageSrc : require('@/assets/images/img-placeholder.png');
      });
    },
    createBussCategory() {
      var categoryObj = { ...this.businessCategoryItem };
      delete categoryObj.productId;

      if (this.businessLogo.base64) {
        var businessLogo = { ...this.businessLogo };
        businessLogo.folder = this.folder;

        this.uploadLogo(businessLogo)
          .then((imageKey) => {
            categoryObj = {
              ...categoryObj,
              productImageSrc: imageKey,
            };

            this.create(categoryObj);
          })
          .catch((err) => {
            Swal.fire("Upload Failed!", `${err}`, "error");
          });
      } else {
        this.create(categoryObj);
      }
    },
    saveBussCategory() {
      var categoryObj = { ...this.businessCategoryItem };
      delete categoryObj['productImageSrc'];

      if (this.businessLogo.base64) {
        var businessLogo = { ...this.businessLogo };
        businessLogo.folder = this.folder;

        this.uploadLogo(businessLogo)
          .then((imageKey) => {
            categoryObj = {
              ...categoryObj,
              productImageSrc: imageKey
            }
            this.update(categoryObj);
          })
          .catch((err) => {
            Swal.fire("Upload Failed!", `${err}`, "error");
          });
      } else {
        this.update(categoryObj);
      }
    },
    create(categoryObj) {
      this.createBusinessCategory(categoryObj)
        .then(() => {
          Swal.fire("Create Successful!", `${categoryObj.productName} has been created.`, "success")
          .then(() => {
            this.clearLogo();
            this.$router.back();
          });
        })
        .catch((e) => {
          Swal.fire("Create Failed!", `${e}`, "error");
          this.clearLogo();
        });
    },
    update(categoryObj){
      this.updateBusinessCategory(categoryObj)
        .then(() => {
          Swal.fire("Update Successful!", `${categoryObj.productName} has been updated.`, "success")
          .then(() => {
            this.clearLogo();
            this.$router.back();
          });
        })
        .catch((e) => {
          Swal.fire("Update Failed!",`${e}`, "error");
          this.clearLogo();
        });
    },
    clearLogo(){
      this.businessLogo = {
        filename: null,
        type: null,
        base64: null
      }
    },
    clearCategory(){
      this.businessCategoryItem = {
        productId: null,
        productName: '',
        productImageSrc: ''
      }
    },
    leaveform(modal = "add") {
      if (
        JSON.stringify(this.businessCategoryItem) ==
        JSON.stringify(this.formExitChecker)
      ) {
        if (modal == "add") {
          this.createModal = false;
        } else if (modal == "edit") {
          this.editModal = false;
        }
        this.clearCategory();
        return;
      }
      Swal.fire({
        title: "Are you sure?",
        text: "you want to leave this page?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "##804997",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes",
        cancelButtonText: "No",
      }).then((result) => {
        if (result.isConfirmed) {
          if (modal == "add") {
            this.createModal = false;
          } else if (modal == "edit") {
            this.editModal = false;
          }
          this.clearCategory();
        } else {
          return;
        }
      });
    },
    getValidationState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null;
    },
  },
};
</script>

<template>
  <div class="row">
    <div class="col-md-3">&nbsp;</div>
    <div class="card col-md-6">
      <div class="card-body">
        <div class="row">
          <ValidationObserver v-slot="{ handleSubmit, reset }">
            <b-form class="px-4 py-3" @submit.prevent="handleSubmit(action == 'add' ? createBussCategory : saveBussCategory)
            " @@reset.prevent="reset">
              <div class="row">
                <label v-if="
                  action == 'add' && !businessCategoryModule.access.create
                " class="form-label medium fw-bold text-danger mb-3">Note: Your access is limited. You cannot create
                  a Business Category.</label>
                <label v-if="
                  action == 'edit' && !businessCategoryModule.access.update
                " class="form-label medium fw-bold text-danger mb-3">Note: Your access is limited. You cannot update
                  a Business Category.</label>
                <div class="col-md-12 mb-3">
                  <label class="form-label small fw-bold">Business Category<span style="color: red">*</span></label>
                  <validation-provider name="Category name" rules="required" v-slot="validationContext">
                    <b-form-input type="text" class="form-control" placeholder="Enter Business Category"
                      :state="getValidationState(validationContext)"
                      v-model="businessCategoryItem.productName" />
                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </validation-provider>
                </div>
                <div class="col-md-12 mb-3">
                  <image-upload 
                    v-if=" action == 'add' ? true : businessCategoryItem.productImageSrc != '' "
                    v-model="businessLogo" 
                    label="Category Logo"
                    :imageSrc="businessCategoryItem.productImageSrc"
                    :isRequired="true" />
                </div>
              </div>

              <div class="text-end mt-3">
                <b-button variant="light" class="w-sm" type="button" @click="$router.back()">Close</b-button>
                <b-button 
                  :disabled="action == 'add' ? !businessCategoryModule.access.create : !businessCategoryModule.access.update" 
                  variant="primary" class="w-sm ms-2" type="submit">Save</b-button>
              </div>
            </b-form>
          </ValidationObserver>
        </div>
      </div>
    </div>
  </div>
</template>
